export const urls = {
	general: {
		checklists: "corplife/checklists"
	},
	files: {
		file: "corplife/files/checklist",
		multiple: "corplife/files/checklist/multiple"
	}
}
